import styled from 'styled-components';
import {dFlexCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const rightGroup = styled.div`
    ${dFlexCenter}
    gap: 8px;
`;

export const dateBtnWrap = styled.div`
    position: relative;
    order: -1;
    ${mobileMedia} {
        order: 0;
    }
`;
